var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"tag":"span","to":_vm.generatePath(_vm.token)}},[_c('a',{class:_vm.classes,attrs:{"target":_vm.target}},[_vm._v(_vm._s(_vm.text || _vm.generateUrl(_vm.token)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }